export { default } from "./DialogContentText.js";
export { default as dialogContentTextClasses } from "./dialogContentTextClasses.js";
export * from "./dialogContentTextClasses.js";